/* Centralized translations so all pages can share the same copy */
export const T = {
  en: {
    navFeatures: 'Features',
    navPrices: 'Prices',
    navCommunity: 'Community',
    navCta: 'Get Started',
    navLogin: 'Login',
    navSignup: 'Sign up',
    navHome: 'Home',

    bismillah: '\u0628\u0650\u0633\u0652\u0645\u0650 \u0627\u0644\u0644\u0651\u064E\u0647\u0650 \u0627\u0644\u0631\u0651\u064E\u062D\u0652\u0645\u064E\u0646\u0650 \u0627\u0644\u0631\u0651\u064E\u062D\u0650\u064A\u0645\u0650',
    heroTag: 'Local Price Comparison',
    heroH1a: 'Compare Groceries,',
    heroH1b: 'Shop Smarter.',
    heroDesc:
      'Barakah helps you compare product prices across local shops near you find the best deals, discover nearby stores, and make informed decisions before you leave home.',
    heroCta1: 'I Own a Grocery Shop',
    heroCta2: "I'm Comparing Prices",
    scroll: 'Scroll',

    pathsTag: 'Two Perspectives, One Platform',
    pathsH2: 'Built for shop owners and their customers.',
    pathsOwnerH3: 'For Shop Owners',
    pathsShopperH3: 'For Shoppers',

    ownerFeatures: [
      {
        num: '01',
        title: 'List Your Shop',
        desc: 'Register your shop with its location, category, photos, and operating hours. Let nearby customers discover you.',
      },
      {
        num: '02',
        title: 'Upload Your Prices',
        desc: 'List your products with images, descriptions, and pricing. Update daily to keep customers informed.',
      },
      {
        num: '03',
        title: 'Smart Price Awareness',
        desc: 'Get notified when nearby shops list similar products at lower prices. Stay competitive with intelligence, not guesswork.',
      },
      {
        num: '04',
        title: 'Connect with Customers',
        desc: 'Chat directly with curious shoppers who want to know more before visiting your store.',
      },
    ],
    shopperFeatures: [
      {
        num: '01',
        title: 'Browse Nearby Shops',
        desc: 'Your feed shows shops closest to you first. Check their prices and products before you visit.',
      },
      {
        num: '02',
        title: 'Compare Prices',
        desc: 'Looking for a specific product? Search across all shops  results sorted by distance, showing price and ratings.',
      },
      {
        num: '03',
        title: 'Wishlist & Price Alerts',
        desc: "Save items you buy often. Get notified when a nearby shop offers them at the best price you've seen.",
      },
      {
        num: '04',
        title: 'Rate & Review',
        desc: 'Visited a shop? Share your experience with star ratings and reviews. Help the community find the best local grocers.',
      },
    ],

    pricesTag: 'Price Intelligence',
    pricesH2: 'Never overpay for products.',
    pricesDesc1:
      'Track the items you buy often. Barakah monitors prices across every shop in your area and alerts you whenever a better price pops up nearby so you always know where to go.',
    pricesDesc2:
      'Shop owners get the same intelligence in reverse know when a nearby competitor is listing lower prices, so you can adjust with confidence.',

    alertLabel: 'Price Alert',
    item1Name: 'Organic Sidr Honey',
    item1Shop: 'Al Noor Grocery\u00b70.4 km',
    item1Price: '৳1899',
    item1Was: '৳2450',
    item1Pct: '23% lower',
    item2Name: 'Ajwa Dates (1 kg)',
    item2Shop: 'Madinah Market\u00b71.1 km',
    item2Price: '৳3200',
    item2Was: '৳3800',
    item2Pct: '16% lower',
    viewAlerts: 'View All Alerts',

    communityH2: 'Trust is built by people.',
    communityDesc:
      'Rate shops. Write reviews. Chat directly with owners. Every interaction strengthens the fabric of your local community.',

    reviewText:
      '"Bought fresh dates here for Ramadan. The quality was excellent and the owner was very helpful. Highly recommended for the neighborhood."',
    reviewAuthor: 'Ahmed K.',
    reviewTime: '2 days ago',

    chatShopName: 'Madinah Market',
    chatOnline: 'Online',
    chatMsg1: 'Assalamu Alaikum! Do you have Ajwa dates in stock?',
    chatMsg2: 'Wa Alaikum Assalam! Yes, fresh stock arrived today. 1 kg for ৳3200',
    chatMsg3: "Perfect, I'll come by after Maghrib inshaAllah",
    chatPlaceholder: 'Type a message...',

    ayah: '\u0648\u064E\u062A\u064E\u0639\u064E\u0627\u0648\u064E\u0646\u064F\u0648\u0627 \u0639\u064E\u0644\u064E\u0649 \u0627\u0644\u0628\u0650\u0631\u0651\u0650 \u0648\u064E\u0627\u0644\u062A\u0651\u064E\u0642\u0652\u0648\u064E\u0649\u0670',
    ayahTranslation: '"And cooperate in righteousness and piety." Al Ma\'idah 5:2',
    ctaH2: 'Start Comparing.',
    ctaDesc:
      "Whether you're listing your shop for locals to find or searching for the best prices in your area your place is here. We don't sell anything we just help you compare.",
    ctaBtn1: 'Register Your Shop',
    ctaBtn2: 'Start Comparing Prices',

    footerTagline: 'Compare local prices near you, built with intention.',
    footerTop: 'Top',
    footerFeatures: 'Features',
    footerPrices: 'Prices',
    footerCommunity: 'Community',
    footerCopyright: (year) => `\u00a9 ${year} Barakah. Not a marketplace  a smarter way to compare.`,

    authLoginTitle: 'Welcome back',
    authLoginSubtitle: 'Log in to continue.',
    authSignupTitle: 'Create your account',
    authSignupSubtitle: 'Join Barakah and get started in minutes.',
    authVerifyTitle: 'Verify your email',
    authVerifySubtitle: 'We sent a verification link to your email. Open it to confirm your account.',

    labelName: 'Full name',
    labelEmail: 'Email',
    labelPassword: 'Password',
    labelPassword2: 'Confirm password',

    actionLogin: 'Login',
    actionSignup: 'Sign up',
    actionResend: 'Resend email',
    actionChangeEmail: 'Change email',
    actionBackToLogin: 'Back to login',
    actionGoogle: 'Continue with Google',

    helperNoAccount: "Don't have an account?",
    helperHaveAccount: 'Already have an account?',
    helperRemember: 'Remember me',
    helperForgot: 'Forgot password?',

    roleTitle: 'I am here as',
    roleOwnerTitle: 'Shop owner',
    roleOwnerDesc: 'List your shop and update prices.',
    roleConsumerTitle: 'Customer',
    roleConsumerDesc: 'Compare prices and get alerts.',

    verifySentTo: (email) => `Sent to ${email}`,
  },

  bn: {
    navFeatures: 'ফিচার',
    navPrices: 'দাম',
    navCommunity: 'কমিউনিটি',
    navCta: 'শুরু করি',
    navLogin: 'লগ ইন',
    navSignup: 'সাইন আপ',
    navHome: 'হোম',

    bismillah: 'بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ',
    heroTag: 'লোকাল পণ্যের দাম তুলনা',
    heroH1a: 'দাম মিলিয়ে নিন,',
    heroH1b: 'আরও স্মার্টভাবে কিনুন।',
    heroDesc: 'বাসা থেকে বের হওয়ার আগে আশেপাশের দোকানগুলোর পণ্যের দাম দেখে নিন। কোথায় ভালো ডিল আছে, কোন দোকান কাছে, সব এক জায়গায়।',
    heroCta1: 'আমি দোকান চালাই',
    heroCta2: 'আমি দাম তুলনা করছি',
    scroll: 'স্ক্রল করুন',

    pathsTag: 'দুই দিক, এক প্ল্যাটফর্ম',
    pathsH2: 'দোকানদার আর ক্রেতা, দুজনের জন্যই।',
    pathsOwnerH3: 'দোকানদারদের জন্য',
    pathsShopperH3: 'ক্রেতাদের জন্য',

    ownerFeatures: [
      { num: '০১', title: 'দোকান যোগ করুন', desc: 'লোকেশন, ক্যাটাগরি, ছবি আর খোলার সময় দিয়ে প্রোফাইল বানান। কাছের মানুষ সহজে খুঁজে পাবে।' },
      { num: '০২', title: 'দাম আপডেট দিন', desc: 'পণ্যের ছবি, বিবরণ আর দাম দিন। নিয়মিত আপডেট করলে ক্রেতারা ঠিক তথ্য পাবে।' },
      { num: '০৩', title: 'দামের খবর পান', desc: 'পাশের দোকান একই পণ্য কম দামে দিলে নোটিফিকেশন পাবেন। আন্দাজ না, তথ্য দেখে সিদ্ধান্ত নিন।' },
      { num: '০৪', title: 'ক্রেতাদের সাথে কথা বলুন', desc: 'কেউ জানতে চাইলে চ্যাটে রিপ্লাই দিন। আসার আগেই তাদের প্রশ্নের উত্তর দিন।' },
    ],
    shopperFeatures: [
      { num: '০১', title: 'কাছের দোকান দেখুন', desc: 'আপনার কাছের দোকানগুলো আগে দেখাবে। যাওয়ার আগে দাম আর পণ্য দেখে নিন।' },
      { num: '০২', title: 'দাম মিলিয়ে নিন', desc: 'যে পণ্য খুঁজছেন, সব দোকানে একসাথে সার্চ করুন। দূরত্ব অনুযায়ী সাজানো ফলাফল, সাথে দাম আর রেটিং।' },
      { num: '০৩', title: 'উইশলিস্ট আর অ্যালার্ট', desc: 'যে জিনিসগুলো বারবার কেনেন সেভ করে রাখুন। ভালো দাম পেলেই জানিয়ে দেবে।' },
      { num: '০৪', title: 'রেটিং দিন, রিভিউ লিখুন', desc: 'দোকানে গেলে স্টার দিন আর ছোট করে রিভিউ লিখুন। সবাই মিলে ভালো দোকান খুঁজে পাওয়া সহজ হবে।' },
    ],

    pricesTag: 'দামের অ্যালার্ট',
    pricesH2: 'একই জিনিসে বেশি টাকা না।',
    pricesDesc1: 'যে পণ্যগুলো নিয়মিত কেনেন সেগুলো ট্র্যাক করুন। আশেপাশের দোকানগুলোর দাম দেখে, ভালো দাম পেলেই নোটিফাই করবে।',
    pricesDesc2: 'দোকানদারদের জন্যও সুবিধা আছে। পাশের দোকান কম দামে দিলে আপনি আগেই জেনে যাবেন, দরকার হলে দাম ঠিক করতে পারবেন।',

    alertLabel: 'দাম অ্যালার্ট',
    item1Name: 'সিদর মধু',
    item1Shop: 'আল নূর গ্রোসারি\u00b7০.৪ কিমি',
    item1Price: '৳১৮.৯৯',
    item1Was: '৳২৪.৫০',
    item1Pct: '২৩% কম',
    item2Name: 'আজওয়া খেজুর (১ কেজি)',
    item2Shop: 'মদিনা মার্কেট\u00b7১.১ কিমি',
    item2Price: '৳৩২.০০',
    item2Was: '৳৩৮.০০',
    item2Pct: '১৬% কম',
    viewAlerts: 'সব অ্যালার্ট দেখুন',

    communityH2: 'বিশ্বাস আসে মানুষের হাত ধরে।',
    communityDesc: 'রেটিং দিন, রিভিউ লিখুন, দরকার হলে মালিকের সাথে চ্যাট করুন। ছোট ছোট অভিজ্ঞতা মিলেই কমিউনিটি শক্ত হয়।',

    reviewText: '"রমজানে এখান থেকে খেজুর নিয়েছিলাম। একদম ফ্রেশ ছিল। দোকানদার ভাইও খুব হেল্পফুল। রেকমেন্ড করবো।"',
    reviewAuthor: 'আহমেদ কে.',
    reviewTime: '২ দিন আগে',

    chatShopName: 'মদিনা মার্কেট',
    chatOnline: 'অনলাইন',
    chatMsg1: 'আসসালামু আলাইকুম! আজওয়া খেজুর আছে?',
    chatMsg2: 'ওয়ালাইকুম আসসালাম! জি আছে। আজই ফ্রেশ স্টক এসেছে। ১ কেজি ৳৩২।',
    chatMsg3: 'দারুণ। ইনশাআল্লাহ মাগরিবের পর আসছি।',
    chatPlaceholder: 'মেসেজ লিখুন...',

    ayah: 'وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ',
    ayahTranslation: '"এবং পুণ্য ও তাকওয়ার কাজে একে অপরকে সহায়তা করো।" আল মায়িদাহ ৫:২',
    ctaH2: 'তুলনা শুরু করুন।',
    ctaDesc: 'আপনি দোকান চালান, বা শুধু সেরা দামে বাজার করতে চান। এখানে দুটোই পারবেন। আমরা কিছু বিক্রি করি না, শুধু তুলনা করতে সাহায্য করি।',
    ctaBtn1: 'দোকান রেজিস্টার করুন',
    ctaBtn2: 'দাম তুলনা শুরু করুন',

    footerTagline: 'কাছের দোকানের দাম তুলনা করুন, মন দিয়ে বানানো।',
    footerTop: 'উপরে',
    footerFeatures: 'ফিচার',
    footerPrices: 'দাম',
    footerCommunity: 'কমিউনিটি',
    footerCopyright: (year) => `© ${year} বারাকাহ। কোনো মার্কেটপ্লেস না, শুধু তুলনা করার স্মার্ট উপায়।`,

    authLoginTitle: 'ফিরে আসায় ভালো লাগলো',
    authLoginSubtitle: 'লগ ইন করে শুরু করুন।',
    authSignupTitle: 'অ্যাকাউন্ট খুলুন',
    authSignupSubtitle: 'এক মিনিটেই শুরু হয়ে যাবে।',
    authVerifyTitle: 'ইমেইল ভেরিফাই করুন',
    authVerifySubtitle: 'আপনার ইমেইলে একটা লিংক পাঠানো হয়েছে। লিংক খুলে কনফার্ম করুন।',

    labelName: 'নাম',
    labelEmail: 'ইমেইল',
    labelPassword: 'পাসওয়ার্ড',
    labelPassword2: 'পাসওয়ার্ড আবার',

    actionLogin: 'লগ ইন',
    actionSignup: 'সাইন আপ',
    actionResend: 'আবার পাঠান',
    actionChangeEmail: 'ইমেইল বদলান',
    actionBackToLogin: 'লগ ইন এ ফিরুন',
    actionGoogle: 'Google দিয়ে চালিয়ে যান',

    helperNoAccount: 'অ্যাকাউন্ট নেই?',
    helperHaveAccount: 'আগেই অ্যাকাউন্ট আছে?',
    helperRemember: 'মনে রাখুন',
    helperForgot: 'পাসওয়ার্ড ভুলে গেছেন?',

    roleTitle: 'আমি এখানে',
    roleOwnerTitle: 'দোকানদার',
    roleOwnerDesc: 'দোকান লিস্ট আর দাম আপডেট দেবেন।',
    roleConsumerTitle: 'ক্রেতা',
    roleConsumerDesc: 'দাম তুলনা আর অ্যালার্ট পাবেন।',

    verifySentTo: (email) => `${email} এ পাঠানো হয়েছে`,
  },
};
